module.exports = __webpack_public_path__ + "static/media/clases-1.3157e250.jpg";